<template>
  <el-form-item label="Workgroup">
    <el-select v-model="workgroupId" style="width: 100%" size="mini">
      <el-option
        v-for="workgroup in workgroups"
        :key="workgroup.id"
        :label="workgroup.name"
        :value="workgroup.id"
      />
    </el-select>
  </el-form-item>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useStore } from "@/utils/useStore";

const store = useStore();

const workgroups = computed(() => store.getters["app/workgroups"]);

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:value", "input"]);

const workgroupId = ref<number>(props.value);

watch(
  () => props.value,
  () => {
    workgroupId.value = props.value;
  }
);

watch(workgroupId, () => {
  emit("input", workgroupId.value);
  emit("update:value", workgroupId.value);
});
</script>
